module.exports = __webpack_public_path__ + "assets/pictograms/tiktok.76e81c9650bf3d5388e08fe31463a07c.svg";